import { useState } from 'react';
import { Box, makeStyles, ButtonBase } from '@material-ui/core';
import { DropRightIcon, FemaleIcon, MaleIcon } from '../../../../components/Icon';
import Text from '../../../../components/Text';
import InProgress from '../InProgress';
import { Triangle } from '../../components/Triangle';
import { initValue } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  round: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
  },
  femaleIcon: {
    fontSize: '1.25rem',
    color: '#FF8181',
  },
  maleIcon: {
    fontSize: '1.25rem',
    color: '#538FFF',
  },
  button: {
    borderRadius: '4px',
    backgroundColor: '#FFF',
    border: '1px solid #E4E7EB',
    width: '2rem',
    height: '2rem',
  },
  dropRightIcon: {
    fontSize: '0.875rem',
    color: '#538FFF',
  },
  inHour: {
    fontSize: '0.75rem',
    color: '#7D86A9',
    fontFamily: 'NotoSans-Bold',
    position: 'absolute',
    top: '100%',
    left: '0',
    whiteSpace: 'nowrap',
    lineHeight: '1.25rem',
  },
}));

const StatusRow = ({ data }) => {
  const classes = useStyles();
  const [ctrlInProgress, setCtrlInProgress] = useState(false);

  return (
    <>
      <Box display="flex" justifyContent="space-between" gridGap="1.44rem">
        {/* Status */}
        <Box display="flex" flexWrap="wrap">
          {/* In Progress */}
          <Box display="flex" alignItems="center" gridGap="0.63rem">
            <Box display="flex" p="0.25rem 0" borderRadius="4px">
              <Box display="flex" gridGap="0.62rem" alignItems="center" width="10rem" height="2.75rem" flex="1">
                <Box className={classes.round} bgcolor="#FA8A82" />
                <Text fontSize="1rem" color="#2E4469">
                  Pending:
                </Text>
                <Text fontSize="1.5rem" color="#2E4469" fontWeight="700">
                  {data?.pendingCount}
                </Text>
              </Box>
              <Box display="flex" alignItems="center" height="2.75rem" p="0 0.75rem" gridGap="0.75rem">
                <Box className={classes.round} bgcolor="#FECA06" />
                <Text fontSize="1rem" color="#2E4469">
                  In Progress:
                </Text>
                <Text fontWeight="700" fontSize="1.5rem" color="#2E4469">
                  {data?.progressCount}
                </Text>
              </Box>
              <Box display="flex" alignItems="center" height="2.75rem" p="0 0.75rem" gridGap="1.25rem">
                <Box display="flex" gridGap="0.25rem">
                  <MaleIcon className={classes.maleIcon} />
                  <Text color="#538FFF">{initValue(data?.admStatic?.maleCount, '')}</Text>
                </Box>
                <Box display="flex" gridGap="0.25rem">
                  <FemaleIcon className={classes.femaleIcon} />
                  <Text color="#FF8181">{initValue(data?.admStatic?.femaleCount, '')}</Text>
                </Box>
                <Triangle number={1} color="#951B07" value={data?.admStatic?.priority1} />
                <Box display="flex" gridGap="0.25rem">
                  <Text color="#2e4469">Total:</Text>
                  <Text>{data?.admStatic?.total}</Text>
                </Box>
              </Box>
            </Box>
            <ButtonBase className={classes.button} onClick={() => setCtrlInProgress(true)}>
              <DropRightIcon className={classes.dropRightIcon} />
            </ButtonBase>
          </Box>
        </Box>
      </Box>
      <InProgress
        open={ctrlInProgress}
        handleBack={() => setCtrlInProgress(false)}
        admSpecStatic={data?.admSpecStatic}
      />
    </>
  );
};

export default StatusRow;
